module.exports = __webpack_public_path__ + "img/Sonnenflecken.a0521778.jpg";